var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowUp = function SvgArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M21.483 13.248c-.689.689-1.806.689-2.495 0l-5.223-5.223v12.21a1.765 1.765 0 1 1-3.53 0V8.025l-5.222 5.223a1.765 1.765 0 1 1-2.496-2.496l8.235-8.235c.69-.69 1.807-.69 2.496 0l8.235 8.235c.69.69.69 1.807 0 2.496",
    clipRule: "evenodd"
  })));
};
export default SvgArrowUp;